import { createFileRoute, redirect } from '@tanstack/react-router'

// The section was renamed from Insights to Data Sources. Sends old links and bookmarks, with their search and hash,
// to the same page under the new path.
export const Route = createFileRoute('/_auth/_modules/crt/materials/insights/$')({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: location.href.replace('/crt/materials/insights', '/crt/materials/data-sources'),
      replace: true,
    })
  },
})
